<template>
  <AuthCard>
    <div class="text-center"><h4>Reset password</h4></div>
    <form @submit.prevent="updatePassword">
      <Input
        v-model="newPassword"
        label="New password"
        name="newPassword"
        type="password"
        :disabled="loading"
        ref="newPassword"
      />
      <Input
        v-model="confirmNewPassword"
        label="Confirm new password"
        name="confirmNewPassword"
        type="password"
        :disabled="loading"
        class="my-4"
      />
      <div class="xs12">
        <Button
          type="submit"
          variant="smooth primary"
          :disabled="loading || newPassword !== confirmNewPassword || !newPassword"
          class="mb-2 width100"
          :loading="loading"
        >
          Update password
        </Button>
      </div>
    </form>
  </AuthCard>
</template>

<script>
  import Button from '../common/Button.vue'
  import Input from '../common/Input.vue'
  import AuthCard from '../common/AuthCard.vue'

  export default {
    name: 'ResetPasswordChange',
    components: { Button, Input, AuthCard },
    data: () => ({
      loading: false,
      newPassword: '',
      confirmNewPassword: ''
    }),
    mounted() {
      this.$refs.newPassword.focus()
    },
    methods: {
      async updatePassword() {
        this.loading = true
        await this.$store.dispatch('resetPasswordChangePassword', {
          newPassword: this.newPassword,
          token: this.$route.params.token
        })
        this.loading = false
        this.$router.push({ name: 'signIn' })
      }
    }
  }
</script>
